module.exports = __webpack_public_path__ + "img/Energetic Driver.6f52d29d.svg";